<template>
  <el-popover
    placement="bottom-start"
    popper-class="switch-client-popover"
    :width="260"
    trigger="click"
    :visible-arrow="false"
    v-model="visible"
    @after-leave="closeSearchClient"
    @show="onShow"
  >
    <div class="search-wrap">
      <div class="header">
        <span class="header-title">{{ $t('callPopScreen.switchClient') }}</span>
        <span @click="visible = false" class="iconfont icon-guanbi-line"></span>
      </div>
      <el-input
        :placeholder="$t('callPopScreen.clientNamePhoneSearch')"
        v-model="searchClientVal"
        @keydown.native.enter="searchClient"
        size="small"
        class="search-input"
        clearable
        @clear="searchClient"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchClient"></el-button>
      </el-input>
      <div class="search-list">
        <div v-if="!searchClientData.rows" class="client-empty">
          <img src="@/assets/images/img_jichu.png" />
          <span>{{ $t('callPopScreen.switchClientTip') }}</span>
        </div>
        <div v-else class="search-list-wrap">
          <div class="search-list-wrap-header">{{ $t('callPopScreen.searchResultTotal', { count: searchClientData.total }) }}</div>
          <div class="search-list-wrap-scroll" v-if="searchClientData.total">
            <div
              v-for="(item) in searchClientData.rows"
              @click="switchClient(item)"
              :key="item.id"
              :class="['search-list-wrap-item', { selected: cleId === item.id }]"
            >
              <div class="search-list-wrap-item-header">
                <span class="name">{{item.cle_name || $t('callPopScreen.unknownClient')}}</span>
                <span class="phone">{{item.cle_phone}}</span>
              </div>
              <div class="search-list-wrap-item-bottom">
                <span>{{ $t('callPopScreen.createTime') }}{{item.create_time}}</span>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="client-empty">
              <img src="@/assets/images/img_jichu.png" />
              <span>{{ $t('callPopScreen.switchClientTip') }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <template slot="reference">
      <slot></slot>
    </template>
  </el-popover>
</template>

<script>
import { getClientSimpleSearch } from "@/api/crm";
export default {
  props: {
    cleId: {
      type: String,
      default: ''
    },
    clePhone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchClientData: {},
      searchClientVal: '',
      visible: false
    }
  },
  methods: {
    searchClient() {
      const { my: { crm_page } } = this._config.URL;
      const val = this.searchClientVal.trim()
      if(val) {
        const param = {}
        if(/^\d+$/.test(val)) {
          param.phone = val
        } else {
          param.cle_name = val
        }
        getClientSimpleSearch(crm_page, param).then(res => {
          if(res.code === 0 || res.code === 200) {
            this.searchClientData = res.data
          }
        })
      }
    },
    switchClient(item) {
      this.$emit('switchclient', item)
    },
    closeSearchClient() {
      this.searchClientData = {}
      this.searchClientVal = ''
    },
    onShow() {
      this.searchClientVal = this.clePhone
      this.searchClient()
    }
  }
}
</script>

<style lang="less">
.switch-client-popover {
  .search-wrap {
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      color: #323233;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      .iconfont {
        cursor: pointer;
        font-size: 12px;
      }
    }
    .search-input {
      margin-bottom: 8px;
    }
    .search-list {
      .client-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        width: 100%;
        height: 220px;
        padding-top: 35px;
        box-sizing: border-box;
        img {
          width: 60px;
        }
        span {
          text-align: center;
          color: #00000040;
          font-size: 12px;
        }
      }
      .search-list-wrap {
        &-header {
          margin-bottom: 8px;
          color: #969799;
          font-size: 12px;
          line-height: 20px;
        }
        &-scroll {
          height: 200px;
          overflow-y: auto;
        }
        .search-list-wrap-item {
          position: relative;
          display: flex;
          flex-direction: column;
          padding: 4px 12px;
          border-radius: 6px;
          cursor: pointer;
          &::before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%);
            width: calc(100% - 20px);
            height: 1px;
            background: #EBEDF0;
          }
          &.selected {
            background: #E6F8FF;
            &::after {
              content: '';
              position: absolute;
              right: 0;
              bottom: 0;
              width: 32px;
              height: 32px;
              background: url(../../../../assets/images/img_dangqian.png) center center/100% 100% no-repeat;
            }
          }
          &:hover {
            background: #F2F3F5;
          }
          &-header {
            display: flex;
            height: 20px;
            justify-content: space-between;
            align-items: center;
            gap: 6px;
            span {
              color: #323233;
              font-size: 12px;
            }
            .name {
              flex: 1;
              width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          &-bottom {
            display: flex;
            align-items: center;
            color: #969799;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/switchClient/index.vue